import React from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'
import { useSession } from '@stores/globalData/globalData.store'
import { FACEBOOK_LINK, INSTAGRAM_LINK, TWITTER_LINK } from '@utils/global'

const SocialNav: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()
  if (!session.community.default_community) return null
  return (
    <>
      <Divider />
      <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.social')}</p>
      <SideNavItem
        href={TWITTER_LINK}
        external
        newTab
        label={t('siteSidebar.twitter')}
        iconName="nf-twitter"
      />
      <SideNavItem
        href={FACEBOOK_LINK}
        external
        newTab
        label={t('siteSidebar.facebook')}
        iconName="nf-facebook"
      />
      <SideNavItem
        href={INSTAGRAM_LINK}
        external
        newTab
        label={t('siteSidebar.instagram')}
        iconName="nf-instagram"
      />
    </>
  )
}
export default SocialNav
